import type { Element } from 'hast';

const INTERNAL_HOSTNAME_IDENTIFIER = 'asknebula.com';

export const isExternalLink = (node: Element) => {
  const href = node?.properties?.href;

  if (typeof href !== 'string') {
    return false;
  }

  if (!/^(?:[a-z]+:)?\/\//i.test(href)) {
    return false;
  }

  const url = new URL(href);

  const isInternalLink = url.hostname.includes(INTERNAL_HOSTNAME_IDENTIFIER);

  return !isInternalLink;
};
